// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d639988a","43":"5e0e6ff1","522":"8cddaaa0","615":"3d81b192","651":"f291a816","833":"255549a7"}[chunkId] + ".chunk.js";
};